import { SalaryBatch, SalaryBatchView } from '../../services/api/api-model';
import { SessionService } from '../../services/session/session.service';

export class SalaryBatchViewModel extends SalaryBatch {
  Id: number;
  CompanyId: number;
  SalaryPeriodId: number;
  Created: Date;
  StatusId: number;
  Approved?: Date;
  RejectionReason?: string;
  Rejected?: Date;
  EIncomeTransferDate?: Date;
  Message?: string;
  PayoutDate: Date;
  ApprovedUserId?: number;
  RejectedUserId?: number;
  CreatedUserId?: number;
  HasErrors: boolean;
  HasWarnings: boolean;
  NetsPaymentsProcessingDate?: Date;
  CreatedByCompanyUserFullName?: string;
  ApprovedByUserFullName?: string;
  RejectedByUserFullName?: string;
  PeriodStartDate: Date;
  PeriodEndDate: Date;
  SalaryCycleId: number;
  LanguageId: number;
  StatusName?: string;
  SalaryBatchNumber: number;
  IsTermination: boolean;
  EIncomeZeroReport: boolean;
  PaymentMethodSalary: number;
  PaymentMethodTax: number;
  PaymentMethodPension: number;
  PaymentMethodVacationProvider: number;
  EIncomeReruns: number;
  PayslipsArchived: boolean;
  LimitToSpecificEmployees: boolean;
  Description?: string;
  PayoutAllFlex: boolean;
  PayoutNewFlex: boolean;
  ValidationStatusCode?: string;
  EditIcon = 'Edit';
  TitleDescription: string;
  FinalizationGuid: string;

  FromDateOverride?: Date;
  ToDateOverride?: Date;

  public ValidationIcon: string;

  constructor(data: SalaryBatchView, sessionService: SessionService) {
    super();
    data.ApprovedByUserFullName = data.ApprovedByUserFullName.trim();
    data.FinalizedByUserFullName = data.FinalizedByUserFullName.trim();
    Object.assign(this, data);
    this.TitleDescription =
      'No. ' +
      this.SalaryBatchNumber +
      ' - ' +
      sessionService.toString(sessionService.parseDate(this.PeriodStartDate as any)) +
      ' - ' +
      sessionService.toString(sessionService.parseDate(this.PeriodEndDate as any)) +
      ' - ' +
      this.StatusName;
    switch (this.ValidationStatusCode) {
      case 'Error':
        this.ValidationIcon = 'ErrorExclamation';
        break;
      case 'Warning':
        this.ValidationIcon = 'Warning';
        break;
      default:
        this.ValidationIcon = '';
    }
  }
}
